(function () {
  var pending = {}, pageRequests = {};
  async function requestPage(page, inStock) {
    var lastError;
    for (var attempt = 0; attempt < 3; attempt++) {
      try {
        var response = await fetch('/collections/all?sort_by=created-descending&' + (inStock ? 'filter.v.availability=1&' : '') + 'section_id=townwine-catalog-feed&page=' + page, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('CATALOG_PAGE_FAILED');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var node = doc.querySelector('[data-townwine-catalog-feed]');
        if (!node) throw new Error('CATALOG_DATA_MISSING');
        var payload = JSON.parse(node.textContent);
        if (!Array.isArray(payload.products) || payload.page !== page) throw new Error('CATALOG_INVALID_PAGE');
        return payload;
      } catch (error) { lastError = error; }
    }
    throw lastError;
  }
  function loadPage(page, inStock) {
    var key = (inStock ? 'stock:' : 'all:') + page;
    if (!pageRequests[key]) pageRequests[key] = requestPage(page, inStock).catch(function(error) { delete pageRequests[key]; throw error; });
    return pageRequests[key];
  }
  window.TownWineCatalog = {
    loadInitial: async function (requiredCount) {
      var products = [], details = {}, page = 1, payload;
      do {
        payload = await loadPage(page++, false);
        products = products.concat(payload.products);
        Object.assign(details, payload.collectorDetails || {});
      } while (payload.hasNextPage && products.length < requiredCount);
      return {products:products, collectorDetails:details, hasNextPage:payload.hasNextPage};
    },
    load: function (options) {
      var inStock = !!(options && options.inStock);
      var key = inStock ? 'stock' : 'all';
      if (pending[key]) return pending[key];
      pending[key] = (async function () {
        var products = new Map(), details = {};
        function merge(payload) {
          payload.products.forEach(function (product) { products.set(product.handle, product); });
          Object.assign(details, payload.collectorDetails || {});
        }
        var first = await loadPage(1, inStock);
        merge(first);
        if (Number.isInteger(first.totalPages) && first.totalPages > 0) {
          for (var page = 2; page <= first.totalPages; page += 4) {
            var requests = [];
            for (var next = page; next < page + 4 && next <= first.totalPages; next++) requests.push(loadPage(next, inStock));
            (await Promise.all(requests)).forEach(merge);
          }
        } else {
          var payload = first, page = 1;
          while (payload.hasNextPage) { payload = await loadPage(++page, inStock); merge(payload); }
        }
        var sorted = Array.from(products.values()).sort(function (a, b) { return (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0); });
        return { page: 1, pageSize: sorted.length, hasNextPage: false, products: sorted, collectorDetails: details };
      })().catch(function (error) { delete pending[key]; throw error; });
      return pending[key];
    }
  };
})();
